import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../config/config'
import NumberFormat from 'react-number-format'

class OutstandingBalanceComponent extends  Component {
  constructor (props) {
    super(props)
    this.state = {
      sum_pay: 0,
      is_load: false
    }

    this.loadDataCarSellPay = this.loadDataCarSellPay.bind(this)
  }

  componentDidMount () {
    this.loadDataCarSellPay()
  }

  loadDataCarSellPay () {
    if (this.props.car_id === '' || this.props.customer_id === '') {
      return
    }
    axios.get(APIURL + '/car_sell_pay/buy/' + this.props.car_id + '/' + this.props.customer_id)
      .then(res => {
        //  car_sell_pay.car_sell_pay_count
        let car_sell_pay_list = res.data
        let sum_pay = car_sell_pay_list.reduce((acc, pay)=>acc + pay.car_sell_pay_count, 0)
        // console.log('sum_pay=', sum_pay)
        this.setState({
          sum_pay: sum_pay,
          is_load: true
        })
      }).catch(error => {
       console.log(error)
      // this.setState({car_sell_pay_list: []})
    })
  }

  render () {
    const { is_load, sum_pay } = this.state
    let bank_finance_id = this.props.bank_finance_id
    let balance_debt = this.props.balance_debt
    let remain = balance_debt - sum_pay

    if (bank_finance_id === 1) {
      remain = balance_debt
    }
    if (balance_debt === sum_pay) {
      remain = 0
    }

    return (
      <>
        {
          is_load === true ?
            <span className="text-primary">ยอดคงเหลือค้างชำระ&nbsp;
            <NumberFormat
              value={remain === 0 ? '-' : remain}
              displayType={'text'} thousandSeparator={true}
              prefix={'฿'}/>
            </span> :
            '...'
        }
      </>
    )
  }

}
export default OutstandingBalanceComponent
